import React from 'react'
import Seat from './seat'

const PlanArea = ({ area, model, instanceId, modelSeats }) => {
  // Don't fetch area status separately - it's included in the main availability data
  const areaStatus = null
  // Check if this area has any seats to render
  const hasDirectSeats = area.seats && Object.keys(area.seats).length > 0
  const hasSeatsInModel = modelSeats && modelSeats.length > 0
  
  // Get seats for this area
  let areaSeats = []
  
  // First, check if area has seats defined directly
  if (hasDirectSeats) {
    // Convert seats object to array if needed
    areaSeats = Array.isArray(area.seats) ? area.seats : Object.values(area.seats)
  } else if (hasSeatsInModel) {
    // Otherwise, filter seats from model that belong to this area
    areaSeats = modelSeats.filter(seat => {
      // Check if seat belongs to this area by matching area ID
      if (seat.areaId === area.id || seat.area === area.id) return true
      
      // Alternative: check if seat position is within area bounds
      if (area.x && area.y && area.width && area.height && seat.x && seat.y) {
        return (
          seat.x >= area.x &&
          seat.x <= area.x + area.width &&
          seat.y >= area.y &&
          seat.y <= area.y + area.height
        )
      }
      
      return false
    })
  }

  // Don't render if no seats found
  if (areaSeats.length === 0) return null

  return (
    <>
      {/* Render area label if available */}
      {area.name && (
        <div
          className='absolute text-xs font-semibold text-gray-600 dark:text-gray-400 pointer-events-none'
          style={{
            left: `${area.x}px`,
            top: `${area.y - 20}px`
          }}
        >
          {area.name}
        </div>
      )}
      
      {/* Render area boundary if needed */}
      {area.showBoundary && (
        <div
          className='absolute border border-gray-300 dark:border-gray-600 pointer-events-none'
          style={{
            left: `${area.x}px`,
            top: `${area.y}px`,
            width: `${area.width}px`,
            height: `${area.height}px`
          }}
        />
      )}
      
      {/* Render seats within this area */}
      {areaSeats.map(seat => {
        // Ensure seat has proper position data and IDs
        const seatData = {
          ...seat,
          id: seat.id || `${area.id}-${seat.name || seat.number}`,
          x: seat.x || (area.x + (seat.relativeX || 0)),
          y: seat.y || (area.y + (seat.relativeY || 0))
        }
        
        // Find the seat status from model if available
        const modelSeat = modelSeats.find(s => s.id === seatData.id)
        
        // Check availability from area status or general availability
        let seatAvailability = modelSeat
        if (!seatAvailability && areaStatus) {
          // Check area-specific availability
          const areaSeatStatus = areaStatus[seatData.id] || areaStatus[seat.name]
          if (areaSeatStatus) {
            seatAvailability = {
              ...seatData,
              available: areaSeatStatus.nok?.length === 0,
              status: areaSeatStatus
            }
          }
        }
        
        const seatWithStatus = seatAvailability || modelSeat || seatData
        
        return (
          <Seat
            key={seatData.id}
            seat={seatWithStatus}
            seatId={seatData.id}
            handleClick={() => {
              // For seats already in basket, always use handleRemoveTicket to toggle removal state
              if (seatWithStatus.alreadyInBasket) {
                model.handleRemoveTicket(seatData.id)
              } else {
                // For new selections, use handleClick
                model.handleClick(seatData.id)
              }
            }}
          />
        )
      })}
    </>
  )
}

export default PlanArea